import { mapGetters } from 'vuex'

export const BetaFeatureMixin = {
  computed: {
    ...mapGetters('visibility', ['betaVisibility']),
  },
  methods: {
    nonBetaRedirect() {
      if (!this.betaVisibility) {
        this.$router.push({name: 'Home'})
      }
    }
  },
  mounted() {
    this.nonBetaRedirect()
  }
}